export default __webpack_public_path__ + "static/media/dm-img.6bf50a7e.webp";